import {
  GeckoCoatingRegion,
  GeckoComponentModelType,
  GeckoCone,
  GeckoConeCircumferentialWeld,
  GeckoConeCourse,
  GeckoConeRadialWeld,
  GeckoConicalPlate,
  GeckoDome,
  GeckoDomeWall,
  GeckoEllipsoidalHead,
  GeckoFeatureModelType,
  GeckoFixedSensor,
  GeckoFlatCircularFloor,
  GeckoHemisphericalHead,
  GeckoHorizontalTankShell,
  GeckoHorizontalWeld,
  GeckoLaunchTube,
  GeckoLeakDetectionValve,
  GeckoLegacyBoilerRepairRegion,
  GeckoLegacyBoilerWall,
  GeckoLegacyBoilerWalls,
  GeckoLegacyCone,
  GeckoLinerRegion,
  GeckoMachinedForgingSimple,
  GeckoManway,
  GeckoNozzle,
  GeckoPipeCircumferentialWeld,
  GeckoPipeIntegralSupport,
  GeckoPipeNonIntegralSupport,
  GeckoPipeSeamWeld,
  GeckoPipeSection,
  GeckoPipeWrap,
  GeckoPlate,
  GeckoPolygonalPlate,
  GeckoPressureVesselShell,
  GeckoShellCourse,
  GeckoShipDeck,
  GeckoShipDeckBitt,
  GeckoShipDeckChock,
  GeckoShipDeckHatch,
  GeckoShipHull,
  GeckoSphericalPlate,
  GeckoTankFlatRoof,
  GeckoTankFloor,
  GeckoTorisphericalHead,
  GeckoVerticalTankFoundation,
  GeckoVerticalTankShell,
  GeckoVerticalWeld,
} from 'types'

/**
 * This mapping provides a connection between the RAM Component enum, and the class that represents it. This allows us
 * to dynamically retrieve the class for instantiation, form fields, etc.
 */
export const AssetModelComponentClassMap = new Map(
  Object.entries({
    [GeckoComponentModelType.VerticalTankShell]: GeckoVerticalTankShell,
    [GeckoComponentModelType.HorizontalTankShell]: GeckoHorizontalTankShell,
    [GeckoComponentModelType.TankFloor]: GeckoTankFloor,
    [GeckoComponentModelType.TankFlatRoof]: GeckoTankFlatRoof,
    [GeckoComponentModelType.PipeSection]: GeckoPipeSection,
    [GeckoComponentModelType.ShipDeck]: GeckoShipDeck,
    [GeckoComponentModelType.BasicShipHull]: GeckoShipHull,
    [GeckoComponentModelType.LegacyBoilerWalls]: GeckoLegacyBoilerWalls,
    [GeckoComponentModelType.LegacyCone]: GeckoLegacyCone,
    [GeckoComponentModelType.Cone]: GeckoCone,
    [GeckoComponentModelType.LaunchTube]: GeckoLaunchTube,
    [GeckoComponentModelType.Dome]: GeckoDome,
    [GeckoComponentModelType.DomeWall]: GeckoDomeWall,
    [GeckoComponentModelType.FlatCircularFloor]: GeckoFlatCircularFloor,
    [GeckoComponentModelType.VerticalTankFoundation]:
      GeckoVerticalTankFoundation,
    [GeckoComponentModelType.MachinedForgingSimple]: GeckoMachinedForgingSimple,
    [GeckoComponentModelType.PressureVesselShell]: GeckoPressureVesselShell,
    [GeckoComponentModelType.HemisphericalHead]: GeckoHemisphericalHead,
    [GeckoComponentModelType.EllipsoidalHead]: GeckoEllipsoidalHead,
    [GeckoComponentModelType.TorisphericalHead]: GeckoTorisphericalHead,
  })
)

/**
 * This mapping provides a connection between the RAM Feature enum and the class that represents it. This allows us to
 * dynamically retrieve a class for instantiate, form fields, etc.
 */
export const AssetModelFeatureClassMap = new Map(
  Object.entries({
    [GeckoFeatureModelType.Course]: GeckoShellCourse,
    [GeckoFeatureModelType.Plate]: GeckoPlate,
    [GeckoFeatureModelType.VerticalWeld]: GeckoVerticalWeld,
    [GeckoFeatureModelType.HorizontalWeld]: GeckoHorizontalWeld,
    [GeckoFeatureModelType.ConeCircumferentialWeld]:
      GeckoConeCircumferentialWeld,
    [GeckoFeatureModelType.ConeRadialWeld]: GeckoConeRadialWeld,
    [GeckoFeatureModelType.Manway]: GeckoManway,
    [GeckoFeatureModelType.Nozzle]: GeckoNozzle,
    [GeckoFeatureModelType.LeakDetectionValve]: GeckoLeakDetectionValve,
    [GeckoFeatureModelType.FixedSensor]: GeckoFixedSensor,
    [GeckoFeatureModelType.ShipDeckBitt]: GeckoShipDeckBitt,
    [GeckoFeatureModelType.ShipDeckChock]: GeckoShipDeckChock,
    [GeckoFeatureModelType.ShipDeckHatch]: GeckoShipDeckHatch,
    [GeckoFeatureModelType.LegacyBoilerWall]: GeckoLegacyBoilerWall,
    [GeckoFeatureModelType.PipeSeamWeld]: GeckoPipeSeamWeld,
    [GeckoFeatureModelType.PipeCircumferentialWeld]:
      GeckoPipeCircumferentialWeld,
    [GeckoFeatureModelType.PipeNonIntegralSupport]: GeckoPipeNonIntegralSupport,
    [GeckoFeatureModelType.PipeIntegralSupport]: GeckoPipeIntegralSupport,
    [GeckoFeatureModelType.PipeWrap]: GeckoPipeWrap,
    [GeckoFeatureModelType.ConeCourse]: GeckoConeCourse,
    [GeckoFeatureModelType.ConePlate]: GeckoConicalPlate,
    [GeckoFeatureModelType.LegacyBoilerRepairRegion]:
      GeckoLegacyBoilerRepairRegion,
    [GeckoFeatureModelType.PolygonalPlate]: GeckoPolygonalPlate,
    [GeckoFeatureModelType.CoatingRegion]: GeckoCoatingRegion,
    [GeckoFeatureModelType.SphericalPlate]: GeckoSphericalPlate,
    [GeckoFeatureModelType.LinerRegion]: GeckoLinerRegion,
  })
)
